<!-- 用户信息 -->
<template>
    <div class="userInfo">
        <div @click="goUserInfoView">
            <img :src="avatar" v-if="avatar" :onerror="imgError" alt="">
            <img src="@/assets/Front/user.png" v-else alt="">
        </div>
        <h3>{{ Info.name }}</h3>
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { getUserInfo, getUserfileimg } from "@/api/base";
import { isIPAddress } from "@/utils/handleUrl";
import Cookies from "js-cookie";

const router = useRouter();
const Info = reactive(JSON.parse(Cookies.get("userInfo")));
// 根据用户头像文件id获取头像地址
const avatar = ref("");
// const Userfileimg = (id) => {
//   if(!id) return
//   getUserfileimg(id).then(res => {
//     if(res.code === 1){
//       if(res.data.accessPath && res.data.accessOutPath){
//         let hostname = window.location.hostname;
//         if (isIPAddress(hostname)) {// 内网
//           avatar.value = res.data.accessPath;
//         }else{// 外网
//           avatar.value = res.data.accessOutPath;
//         }
//       }else{
//         avatar.value = res.data.accessPath ? res.data.accessPath : res.data.accessOutPath;
//       }
//     }
//   })
// }
// 获取用户信息
const getUserDetail = () => {
  getUserInfo(Info.userId).then((res) => {
    if (res.code === 1) {
      avatar.value = res.data.avatar;
      // localStorage.setItem("avatar", avatar.value);
      // Userfileimg(res.data.avatar);
    }
  });
};
const goUserInfoView = () => {
  // 跳转个人信息页
  router.push({
    path: "/wenxiang/userInfo",
  });
};

// 图片裂开无法显示
const imgError = (e) => {
  let img = e.srcElement;
  img.src = require("@/assets/Front/user.png");
  img.onerror = null;
};

onMounted(()=>{
  getUserDetail();
})
onBeforeUnmount(()=>{
  console.log('组件实例被销毁前调用')
})
</script>
<style lang="less" scoped>
.userInfo{
    padding: 56px 0 40px 0;
    border-bottom: 1px solid var(--wx-8EB);
    margin: 0 10px 4px 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    row-gap: 10px;
    div{
        padding: 3.75px;
        width: 64.5px;
        height: 64.5px;
        border-radius: 50%;
        box-shadow: 0px 0px 20px 0px rgba(0, 14, 138, 0.10);
        background-color: var(--Gray-White);
        img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
    h3{
        color: var(--wx-title2);
        font-family: "PingFang SC";
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 140% */
    }
}
</style>
